(function fadeIn() {
    var animatedTags = document.querySelectorAll("section.fade-in-test h1, section.fade-in-test h2, section.fade-in-test h3, section.fade-in-test p, section.fade-in-test img, .fade-in-js");
    var animatedLines = document.querySelectorAll(".fade-in-line");
    var animatedLinesHeight = document.querySelectorAll(".fade-in-line-height");
    animatedTags.forEach(function (tag) {
        tag.style.opacity = "0";
    });
    var fadeIn = function () {
        //   look thru tags, see with getBoundingClientRect() if its in the window
        var delay = 0.25;
        animatedTags.forEach(function (tag) {
            var tagTop = tag.getBoundingClientRect().top;
            var tagBottom = tag.getBoundingClientRect().bottom;
            if (tagTop < window.innerHeight && tagBottom > 0) {
                tag.style.animation = "fadeInLogo 1s " + delay + "s both";
                delay = +0.25;
            }
            else {
                tag.style.opacity = "0";
                tag.style.animation = "";
            }
        });
    };
    animatedLines.forEach(function (tag) {
        tag.style.width = "0%";
    });
    var fadeInLine = function () {
        //   look thru tags, see with getBoundingClientRect() if its in the window
        var delay = 0.25;
        animatedLines.forEach(function (tag) {
            var tagTop = tag.getBoundingClientRect().top;
            var tagBottom = tag.getBoundingClientRect().bottom;
            if (tagTop < window.innerHeight && tagBottom > 0) {
                tag.style.animation = "fadeInLine 1s " + delay + "s both";
                delay = +0.5;
            }
            else {
                tag.style.width = "0%";
                tag.style.animation = "";
            }
        });
    };
    animatedLinesHeight.forEach(function (tag) {
        tag.style.height = "0%";
    });
    var fadeInLineHeight = function () {
        //   look thru tags, see with getBoundingClientRect() if its in the window
        var delay = 0.25;
        animatedLinesHeight.forEach(function (tag) {
            var tagTop = tag.getBoundingClientRect().top;
            var tagBottom = tag.getBoundingClientRect().bottom;
            if (tagTop < window.innerHeight && tagBottom > 0) {
                tag.style.animation = "fadeInLineHeight 1s " + delay + "s both";
                delay = +0.5;
            }
            else {
                tag.style.height = "0%";
                tag.style.animation = "";
            }
        });
    };
    var scrollSections = document.querySelectorAll("div.scroll-cool");
    window.addEventListener("scroll", function () {
        // given to use by the browser
        var scrollPosition = window.pageYOffset;
        // for each span, we're doing something slightly different
        // so lets do a loop for each one
        scrollSections.forEach(function (section, index) {
            var span = section.querySelector("span");
            // move each scroll position per span up by 2000px
            // this gives us 2000px per text to play with
            //@ts-ignore
            var spanScrollPosition = scrollPosition - section.offsetTop;
            // if we're above 1000px in each span's scroll
            if (spanScrollPosition > 500) {
                // fade out, starting at 1 going to 0 opacity
                // - 1000 as we need to factor it where we started
                // 0.001 is just speed of opacity change
                //@ts-ignore
                span.style.opacity = 1 - ((spanScrollPosition) * 0.001);
            }
            else {
                // 0.001 is just speed of opacity change
                //@ts-ignore
                span.style.opacity = spanScrollPosition * 0.005;
            }
            // -0.02 is speed of movement change
            // minus as we're going up page as we scroll down
            var y = spanScrollPosition * -0.02;
            span.style.transform = "translate(0, " + y + "px)";
        });
    });
    fadeIn();
    document.addEventListener("scroll", function () {
        fadeIn();
    });
    window.addEventListener("resize", function () {
        fadeIn();
    });
    fadeInLine();
    document.addEventListener("scroll", function () {
        fadeInLine();
    });
    window.addEventListener("resize", function () {
        fadeInLine();
    });
    fadeInLineHeight();
    document.addEventListener("scroll", function () {
        fadeInLineHeight();
    });
    window.addEventListener("resize", function () {
        fadeInLineHeight();
    });
})();
